
import Button from '@/ui-kit/components/button';
import Gutter from '@/ui-kit/components/gutter';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import SearchFiltersEvents from '../mixins/SearchFiltersEvents';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
} from '@/ui-kit/styles/enums';
import { track } from '@/utils/analytics';
import { SearchFiltersEvent } from '@/constants/AnalyticEvents';

export default {
  name: 'SearchFiltersActions',
  components: {
    Button,
    Gutter,
  },
  mixins: [SearchFiltersEvents],
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    resetButtonText: {
      required: true,
      type: String,
    },
    submitButtonText: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      ButtonFillType,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
    };
  },
  methods: {
    handleSubmitButtonClick() {
      this.emitSubmit();
    },
    handleResetButtonClick() {
      track(SearchFiltersEvent.ListingFiltersReset);
      this.emitReset();
    },
  },
};
